// src/styles/themes.ts
import { DefaultTheme } from 'styled-components'

export type ThemeId = 'light' | 'dark'

export const lightTheme: DefaultTheme = {
  name: 'light',
  background: '#e8edf2', // Fundo branco frio elegante
  surface: '#ffffff', // Superfícies e cartões claros
  surfaceBorder: '#cbd5e1',
  cardBackground: '#ffffff',
  cardBorder: '#e2e8f0',
  shadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
  textPrimary: '#0f172a', // Preto ardósia de alto contraste
  textSecondary: '#475569', // Cinza escuro para textos secundários
  titleColor: '#0f172a', // Título de páginas 100% nítido
  subtitleColor: '#475569', // Subtítulo elegante e legível
  navBackground: '#001f5c', // Cápsula de navegação com contraste garantido
  primary: '#0284c7',
  danger: '#ef4444',
  success: '#16a34a',
}

export const darkTheme: DefaultTheme = {
  name: 'dark',
  background: '#001842',
  surface: '#002b80',
  surfaceBorder: 'rgba(255, 255, 255, 0.1)',
  cardBackground: 'rgba(255, 255, 255, 0.08)',
  cardBorder: 'rgba(255, 255, 255, 0.05)',
  shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3)',
  textPrimary: '#ffffff',
  textSecondary: '#94a3b8',
  titleColor: '#ffffff',
  subtitleColor: '#a6c10b',
  navBackground: 'rgba(0, 31, 92, 0.85)',
  primary: '#3b82f6',
  danger: '#f87171',
  success: '#4ade80',
}
